<ul>
  <li>
    <span class="icon icon-check"></span>
    <p><strong>Encontrar el mejor seguro de salud</strong> entre más de 20 compañías</p>
  </li>
  <li>
    <span class="icon icon-check"></span>
    <p>Saber que encontramos para ti la <strong>mejor póliza porque somos corredores de seguros</strong></p>
  </li>
  <li>
    <span class="icon icon-check"></span>
    <p><strong>Comparar coberturas y precios de tu seguro médico </strong>en minutos</p>
  </li>
  <li>
    <span class="icon icon-check"></span>
    <p>Ahorrar 120€ de media con nuestras ofertas en <strong>seguros médicos</strong></p>
  </li>
</ul>
